import axios from 'axios'

export default {
  getStatsStudentsToPartners() {
    return axios.get('/api/statistics/students-to-partners')
  },
  getClassesStudentsDistribution() {
    return axios.get('/api/statistics/classes-students-distribution')
  },
  getCountSchoolsDOClasses() {
    return axios.get('/api/statistics/count-schools-do-classes')
  },
  getStatsOlympicsResults(id) {
    return axios.get(`/api/statistics/olympics-results/${id}`)
  },
  postStatsStudentsToPartners(data) {
    return axios.post('/api/statistics/students-to-partners', data)
  },
  postCountSchoolsDOClasses(data) {
    return axios.post('/api/statistics/count-schools-do-classes', data)
  },
  postClassesStudentsDistribution(data) {
    return axios.post('/api/statistics/classes-students-distribution', data)
  },
  postStatsOlympicsResults(data) {
    return axios.post('/api/statistics/olympics-results', data)
  },
  getAcademicYears() {
    return axios.get('/api/statistics/academic-years')
  },
  getClassMembers(year) {
    return axios.get(`/api/statistics/class-members/${year}`)
  },
  addNewOlympiad(data) {
    return axios.post('/api/statistics/add-new-olympiad', data)
  },
  deleteOlympiad(id) {
    return axios.delete(`/api/statistics/delete-olympiad/${id}`)
  },
  getStatisticsFromOlympiadApi() {
    return axios.get('/api/jsons/olympiadStats.json')
  },
  setStatisticYear(newYear) {
    return axios.put('/api/admins/statistic/year', { year: newYear })
  },
  getStatisticYear() {
    return axios.get('/api/admins/statistic/year')
  },
  updateStatisticYear() {
    return axios.get('/api/admins/statistic/year/update')
  }
}
